import React from 'react';
import Icon from '../../../components/AppIcon';

const KPICard = ({ label, value, icon, color, bg, onClick }) => (
  <div
    onClick={onClick}
    className={`${bg} rounded-xl border border-border shadow-elevation-1 p-4 ${onClick ? 'cursor-pointer hover:shadow-elevation-2 transition-shadow' : ''}`}
  >
    <div className="flex items-center justify-between mb-2">
      <Icon name={icon} size={18} className={color} />
      {onClick && <Icon name="ArrowUpRight" size={14} className="text-muted-foreground" />}
    </div>
    <p className={`text-2xl font-bold ${color}`}>{value}</p>
    <p className="text-xs text-muted-foreground mt-0.5">{label}</p>
  </div>
);

export default KPICard;
